import { CategoryService } from "../../services/models/category";
const moduleCie10 = {
  namespaced: true,
  state: {
    padre: [],
    loading: false,
  },
  getters: {
    getCie10(state) {
      return state.padre;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    setPadre(state, padre) {
      state.padre = padre;
    },
  },
  actions: {
    //La gran mayoría de esto no lo entiendo, solo copié y pegué
    async loadCie10({ commit, state }) {
      if (state.padre.length !== 0) {
        return;
      }
      state.loading = true;

      // this.padre = [];
      commit("setPadre", []);
      let itemssubc = [];
      let cie10 = [];
      // let response = await GetCategory(this.$http);
      let response;

      const appVersion = process.env.VUE_APP_CIE10_VERSION;
      const browserVersion = window.localStorage.getItem("cie10_version");

      if (localStorage.getItem("cie10") && localStorage.getItem("cie10") != "null" && appVersion == browserVersion) {
        response = JSON.parse(localStorage.getItem("cie10"));
      } else {
        response = await CategoryService.getCategories();
        localStorage.setItem("cie10", JSON.stringify(response));
        localStorage.setItem("cie10_version", appVersion);
      }
      response.forEach((value) => {
        // this.telePadre.push(value.name + "(" + value.id + ")");
        value.children.forEach((valor) => {
          itemssubc.push({ id: valor.id, label: valor.label, labelHtml: valor.label, auge: valor.auge });
          // this.telePadre.push(valor.name + "(" + valor.id + ")");
        });

        cie10.push({
          id: value.id,
          label: value.label,
          labelHtml: value.label,
          auge: value.auge,
          children: itemssubc,
        });
        itemssubc = [];
      });

      // let cie10 = await Cie10Service.getAll();
      commit("setPadre", cie10);

      state.loading = false;
    },
  },
};

export default moduleCie10;
